import { jsx } from "react/jsx-runtime";
import { Box } from "braid-design-system";
import { JobStreetLogo } from "./styles/JobStreet/JobStreet.mjs";
import { JobsDbLogo } from "./styles/JobsDb/JobsDb.mjs";
import { SeekAnzLogo } from "./styles/SeekAnz/SeekAnz.mjs";
const Logo = ({ brand, variant, size }) => {
  const logos = {
    seek: /* @__PURE__ */ jsx(SeekAnzLogo, { variant, size }),
    jobstreet: /* @__PURE__ */ jsx(JobStreetLogo, { variant, size }),
    jobsdb: /* @__PURE__ */ jsx(JobsDbLogo, { variant, size })
  };
  if (!Object.keys(logos).includes(brand)) {
    throw new Error("No brand provided to Logo");
  }
  const logo = logos[brand];
  return size === "fill" ? logo : /* @__PURE__ */ jsx(Box, { component: "span", display: "block", children: logo });
};
export {
  Logo
};
